import { DateObject } from '../reusables/date-object';
import { Status } from '../reusables/status';
import { ReminderStatusTranslationsService } from 'src/app/shared/translations';

/**
 * Blueprint for the user reminder entity.
 */
export class UserReminder {
  public id: string;
  public customer: { id; firstName; lastName; externalNumber; company };
  public owner: { id };
  public text: string;
  public createdAt: DateObject;
  public deadline: DateObject;
  public status: Status;
  public attachment: string;

  public statuses: Array<any> = [
    { value: 'open', status: this.statusTranslations.i18nOpenStatus, class: 'esf-tag--info' },
    { value: 'closed', status: this.statusTranslations.i18nResolvedStatus, class: 'esf-tag--success' },
    { value: 'overdue', status: this.statusTranslations.i18nOverdueStatus, class: 'esf-tag--alert--red' }
  ];

  constructor(reminder: any, private statusTranslations: ReminderStatusTranslationsService) {
    this.id = reminder.reminderId;
    this.customer = reminder.customer;
    this.text = reminder.text;
    this.createdAt = new DateObject(reminder.createdAt, 'dd.MM.yyyy HH:mm');
    this.deadline = new DateObject(reminder.deadline, 'dd.MM.yyyy');
    this.status = this.getFullStatus(reminder.status);
    this.attachment = reminder.attachment;
    this.owner = { id: reminder.ownerId };
  }

  get customerInfo(): string {
    let fullString = '';
    fullString += this.customer.firstName ? `${this.customer.firstName} ` : '';
    fullString += this.customer.lastName ? `${this.customer.lastName} ` : '';
    fullString += this.customer.externalNumber ? `(${this.customer.externalNumber})` : '';
    return fullString;
  }

  get companyInfo(): string {
    let fullString = '';
    fullString += this.customer.company ? `${this.customer.company}` : '';
    return fullString;
  }

  get fullInfo(): string {
    let fullString = '';
    fullString += this.customerInfo ? `${this.customerInfo} <br/>` : '';
    fullString += this.companyInfo ? `${this.companyInfo}` : '';
    return fullString;
  }

  /**
   * Retrieves the status
   */
  public getFullStatus(status: string): any {
    const fullStatus = this.statuses.find(el => status === el.value);
    return fullStatus ? new Status(fullStatus) : status;
  }

}
